/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tag_PragueInputs */

const cs_tag_prague = /** @type {(inputs: Tag_PragueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praha`)
};

const en_tag_prague = /** @type {(inputs: Tag_PragueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prague`)
};

/**
* | output |
* | --- |
* | "Prague" |
*
* @param {Tag_PragueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tag_prague = /** @type {((inputs?: Tag_PragueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tag_PragueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tag_prague(inputs)
	return cs_tag_prague(inputs)
});